import React, { useState } from 'react';
import FormView from '../../components/views/formView';
import { SURVEYLIST } from '../../../routes/paths';
import { useNavigate } from 'react-router-dom';
import { MasterMessage } from '../../../masters/masterMessages';
import StepperGeneral from '../../components/general/stepper/stepper';
import SurveyInformation from './steps/surveyInformation';
import SurveyQuestions from './steps/surveyQuestions';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import { types } from '../../../redux/types';
import AddCircleIcon from '@mui/icons-material/AddCircle';

type Props = {
    idSurvey?: any;
    surveyInfo?: any;
    onSave?: any;
};

const SurveyForm = ({ surveyInfo, idSurvey, onSave }: Props) => {
    const dispatch: any = useDispatch();
    const navigate = useNavigate();
    const { surveys }: any = MasterMessage;
    const { activeStep } = useSelector((state: RootState) => state.general);
    const [saveInfo, setSaveInfo] = useState<any>();
    const [saveQuestions, setSaveQuestions] = useState<any>();
    const [submit, setSubmit] = useState<boolean>(false);

    const steps = [
        {
            label: 'Datos Encuesta',
            component: (
                <SurveyInformation
                    surveyInfo={surveyInfo}
                    idSurvey={idSurvey}
                    onSubmitSave={(value: any) => setSubmit(value)}
                    saveInfo={setSaveInfo}
                    onSave={(value: any) => onSave(value)}
                />
            ),
        },
        {
            label: 'Preguntas Y Respuestas',
            component: (
                <SurveyQuestions
                    idSurvey={idSurvey}
                    saveQuestions={setSaveQuestions}
                />
            ),
        },
    ];

    return (
        <>
            <FormView
                title={idSurvey ? surveys.titleEdit : surveys.titleNew}
                disableAdd={true}
                enabledAddLoading={true}
                titleButtonLoading={
                    activeStep === 0 ? 'Siguiente' : 'Agregar Pregunta'
                }
                loadingPositionButtonLoading="start"
                startIconButtonLoading={
                    activeStep === 0 ? (
                        <ArrowForwardIcon color="secondary" />
                    ) : (
                        <AddCircleIcon color="secondary" />
                    )
                }
                loadingButtonLoading={submit}
                disabledLoadingButton={submit}
                onClickButtonLoading={
                    activeStep === 0 ? saveInfo : saveQuestions
                }
                onClickBack={
                    activeStep === 0
                        ? () => navigate(SURVEYLIST)
                        : () => dispatch({ type: types.backStepper })
                }
            />
            <StepperGeneral steps={steps} />
        </>
    );
};

export default SurveyForm;
